import { lazy } from 'react';

const LazyBaseDialog = lazy(() => import('@glass/shared/components/Dialog/BaseDialog'));

export default LazyBaseDialog;
